/* Dansk katalog for locale-invoice-control.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'control.expand': 'Udvid chat',
  'control.collapse': 'Gør chatten mindre',
  'control.proposalIncomplete': 'Fakturaforslaget er ufuldstændigt. Linjer og detaljer er ikke udfyldt. Angiv det, der mangler, eller gør det færdigt i formularen.',
  'control.reloadRequired': 'Fakturatilstanden er opdateret. Genindlæs siden, før du fortsætter. Ingen felter blev ændret.',
  'control.fieldsApplied': 'Kunden og fakturalinjerne er udfyldt i formularen. Udkastet er ikke gemt.',
  'control.customerApplied': 'Kunden er valgt i fakturaformularen.',
  'control.onepageApplied': 'Visningen er ændret til alt på én side.',
  'control.stepsApplied': 'Visningen er ændret til trinvis udfyldning.',
  'control.editorOpened': 'Siden for nyt salg er åbnet.',
  'control.listOpened': 'Fakturalisten er åbnet.',
  'control.saveReady': 'Udkastet kan gemmes, når du beder mig om det.',
  'control.noChange': 'Ingen felter blev ændret. Beskriv, hvad du vil have på fakturaen.',
  'control.title': 'SuperPlumma gør arbejdet',
  'control.scope': 'Hvad vil du gøre?',
  'control.you': 'Du',
  'control.input': 'Hvad vil du gøre?',
  'control.run': 'Udfør',
  'control.speak': 'Tale',
  'control.stopMic': 'Annuller tale',
  'control.stop': 'Stop',
  'control.minimize': 'Minimer assistenten',
  'control.newChat': 'Start ny samtale',
  'control.working': 'Plumme arbejder …',
  'control.saved': 'Udkastet er gemt. Fakturaen er ikke sendt.',
  'control.reviewHelp': 'Kontrollér fakturaen i forhåndsvisningen. Brug «Opret faktura» og det almindelige afsendelsesvalg for at gøre den færdig.',
  'control.save': 'Gem udkast',
  'control.listening': 'Lytter …',
  'control.voiceUnsupported': 'Denne browser understøtter ikke tale her. Du kan stadig skrive.',
  'control.voiceFailed': 'Talen kunne ikke genkendes. Kontrollér mikrofonadgangen, eller skriv beskeden.',
  'control.editorUnavailable': 'Fakturaeditoren er ikke tilgængelig. Åbn fakturaen, og prøv igen.',
  'control.editorChanged': 'Fakturaen blev ændret, mens jeg arbejdede. Bed om ændringen igen, så bruger jeg de nyeste felter.',
  'control.invoiceOnly': 'Denne tilstand understøtter fakturaer. Brug den almindelige assistent til andre opgaver.',
  'control.agentUnavailable': 'Fakturatilstanden kræver den nye assistenttjeneste. Den er ikke tilgængelig lige nu. Der blev ikke foretaget nogen ændring.',
  'control.advancedInvoice': 'Denne faktura har detaljer, der skal redigeres i formularen i den første version. Ingen felter blev ændret.',
  'control.customerRequired': 'Vælg en eksisterende kunde, eller opret kunden i kunderegistret først.',
  'control.incomplete': 'Vælg en kunde, og tilføj en fakturalinje, før du gemmer.',
  'control.saveBeforeLeaving': 'Gem udkastet, før du går til fakturalisten, så beholder du ændringerne.',
  'control.failed': 'Opgaven kunne ikke gennemføres. Prøv igen.',
  'pageControl.working': 'Arbejder på siden ...',
  'pageControl.done.applied': 'Felterne er opdateret på den almindelige side.',
  'pageControl.done.saved': 'Handlingen er gennemført via sidens almindelige gemmeflow.',
});
